var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgReliabilityinline = function SvgReliabilityinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "m6.66 15.102-.008-.003a7.75 7.75 0 0 1-3.704-2.902A8.3 8.3 0 0 1 1.5 7.588V2.28a.6.6 0 0 1 .092-.32.53.53 0 0 1 .232-.201A15.1 15.1 0 0 1 7.995.5h.01a15.1 15.1 0 0 1 6.171 1.258c.091.04.173.11.232.202a.6.6 0 0 1 .092.319v5.308a8.3 8.3 0 0 1-1.448 4.61 7.75 7.75 0 0 1-3.704 2.901h0l-.007.003-.747.288q0 0 0 0a1.66 1.66 0 0 1-1.188 0zM8 .695v14.608M1.5 6.957h13"
  })));
};
export default SvgReliabilityinline;